import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setConfigNodeLayout, setConfigPathStrategy, setConfigPathAlgorithm, setConfigPathHeuristic, setConfigShowGrid } from '../redux/actions';
import useConfigOptions from '../hooks/useConfigOptions';
import formatOptionLabel from '../utils/formatOptionLabel';

const Config = () => {
    const dispatch = useDispatch();
    const config = useSelector(state => state.config);
    const { options, loading, error } = useConfigOptions();

    const [isVisible, setIsVisible] = useState(false);
    const toggleVisibility = () => {
      setIsVisible(!isVisible);
    };

    const handleShowGrid = (e) => {
      dispatch(setConfigShowGrid(e.target.checked));
    };

    const handleLayoutChange = (e) => {
      dispatch(setConfigNodeLayout(e.target.value));
    };

    const handlePathStrategyChange = (e) => {
      dispatch(setConfigPathStrategy(e.target.value));
    };

    const handlePathAlgorithmChange = (e) => {
      dispatch(setConfigPathAlgorithm(e.target.value));
    };

    const handlePathHeuristicChange = (e) => {
      dispatch(setConfigPathHeuristic(e.target.value));
    };

    // Show error message if config options failed to load
    if (error) {
        return (
            <div className="flex flex-col">
                <button id="configReveal" onClick={toggleVisibility}>{isVisible ? 'Close' : 'Open'} config</button>
                <div id="configOptions" style={{ display: isVisible ? 'block' : 'none' }}>
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                        <p className="font-bold">Configuration Error</p>
                        <p className="text-sm">{error}</p>
                    </div>
                </div>
            </div>
        );
    }

    return (<div className="flex flex-col">
        <button id="configReveal" onClick={toggleVisibility}>{isVisible ? 'Close' : 'Open'} config</button>
        <div id="configOptions" style={{ display: isVisible ? 'block' : 'none' }}>
            {loading && (
                <div className="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded mb-4">
                    Loading configuration options...
                </div>
            )}
            <div>
                <label htmlFor="showGrid">Show grid markers</label>
                <input type="checkbox" id="showGrid" data-cy="show-grid" value={config.showGrid} onChange={handleShowGrid} />
            </div>
            <div>
                 <label htmlFor="nodeLayout">Layout style</label>
                 <select id="nodeLayout" data-cy="node-layout" value={config.nodeLayout} onChange={handleLayoutChange} disabled={loading || !options.layouts.length}>
                     {options.layouts.map((layout) => (
                         <option key={layout} value={layout}>
                             {formatOptionLabel(layout, 'layout')}
                         </option>
                     ))}
                 </select>
             </div>
            <div>
                <label htmlFor="pathStrategy">Path strategy</label>
                <select id="pathStrategy" data-cy="path-strategy" value={config.pathStrategy} onChange={handlePathStrategyChange}>
                    <option value="in-order">Ordered</option>
                    <option value="random">Random</option>
                </select>
            </div>
            <div>
                 <label htmlFor="pathAlgorithm">Path algorithm</label>
                 <select id="pathAlgorithm" data-cy="path-algorithm" value={config.pathAlgorithm || ''} onChange={handlePathAlgorithmChange} disabled={loading || !options.algorithms.length}>
                     <option value="">Default</option>
                     {options.algorithms.map((algorithm) => (
                         <option key={algorithm} value={algorithm}>
                             {formatOptionLabel(algorithm, 'algorithm')}
                         </option>
                     ))}
                 </select>
             </div>
            <div>
                 <label htmlFor="pathHeuristic">Path heuristic</label>
                 <select id="pathHeuristic" data-cy="path-heuristic" value={config.pathHeuristic || ''} onChange={handlePathHeuristicChange} disabled={loading || !options.heuristics.length}>
                     <option value="">Default</option>
                     {options.heuristics.map((heuristic) => (
                         <option key={heuristic} value={heuristic}>
                             {formatOptionLabel(heuristic, 'heuristic')}
                         </option>
                     ))}
                 </select>
             </div>
        </div>
    </div>);
};

export default Config;
